import {COMMA, ENTER} from '@angular/cdk/keycodes';
import {HttpClient} from '@angular/common/http';
import {Component, ElementRef, Inject, OnInit, ViewChild} from '@angular/core';
import {FormControl} from '@angular/forms';
import {MAT_DIALOG_DATA} from '@angular/material';
import {MatAutocompleteSelectedEvent} from '@angular/material/autocomplete';
import {MatDialogRef} from '@angular/material/dialog';
import {Observable} from 'rxjs';
import {debounceTime, finalize, switchMap, tap} from 'rxjs/operators';
import {AuthService} from '../../../services/auth.service';
import {CommonService} from '../../../services/common.service';
import {MessageService} from '../../../services/message.service';
import {ToastMessagesService} from '../../../services/toast-messages.service';

@Component({
    selector: 'app-general-email',
    templateUrl: './general-email.component.html',
    styleUrls: ['./general-email.component.scss']
})

export class GeneralEmailComponent implements OnInit {
    @ViewChild('emailInput', {static: false}) emailInput: ElementRef;
    addOnBlur = true;
    departmentEmails: any;
    editorStyle: any;
    emails: any[] = [];
    emailsCtrl = new FormControl();
    errorMsg: string;
    filteredEmails: Observable<any[]>;
    filteredUsers: any;
    htmlContent: any;
    incomingUserInfo: any;
    isLoading = false;
    mode: number; // 0: reportConsents, 1: reportAffirmations 2: SimpleEmail, 3:ReportDetails 4: parent message
    notificationMode: number;
    recipientsGroup = [];
    removable = true;
    selectable = true;
    selectedRecipientGroup: any;
    separatorKeysCodes = [ENTER, COMMA];
    subject: any;
    loading: boolean;
    parent: any;
    textContent: string;

    constructor(private commonService: CommonService,
                private http: HttpClient,
                private authService: AuthService,
                private messageService: MessageService,
                @Inject(MAT_DIALOG_DATA) public data: any,
                public dialogRef: MatDialogRef<GeneralEmailComponent>,
                public toastMessagesService: ToastMessagesService) {
        this.editorStyle = {height: '500px', width: '100%'};
        this.notificationMode = 4;
        this.mode = data.mode;
        this.loading = false;
        this.textContent = '';
        if (data.emails) {
            this.incomingUserInfo = data.emails;
            console.log(data.emails);
        }

        this.recipientsGroup = this.mode === 0 ? [{
            id: 1,
            label: 'Αποδέχτηκαν'
        },
            {
                id: 2,
                label: 'Απέρριψαν'
            },
            {
                id: 3,
                label: 'Σε αναμονή'
            }] : [{
            id: 1,
            label: 'Αποδέχτηκαν'
        },
            {
                id: 2,
                label: 'Ακύρωσαν'
            },
            {
                id: 3,
                label: 'Σε αναμονή'
            }];

        // From Affirmation Reports
        // if (this.mode === 1) {
        //     this.initializeUsers();
        // }

        console.log(this.mode);
        // Single Parent Email or parent direct message
        if (this.mode === 2 ||  this.mode === 4) {
            console.log('init user');
            this.initializeUser();
        }
    }

    transform(text: string): any {
        const plainText = text.replace(/<(?:.|\n)*?>/gm, ' ');
        return plainText.trim();
    }

    plainTextLength() {
        const plainText = this.htmlContent ? this.htmlContent.replace(/<(?:.|\n)*?>/gm, ' ') : '';
        return plainText.trim().length;
    }

    async initializeUsers(status: number) {
        this.emails = [];
        let emails = [];
        const parents = [];
        const tempParents = [];
        console.log(status);
        if (status === 1) {
            emails = emails.concat(this.incomingUserInfo.completedParentEmails);
        } else if (status === 2) {
            emails = [];
        } else {
            emails = emails.concat(this.incomingUserInfo.notAnsweredParentEmails);
        }

        this.isLoading = true;
        for (const email of emails) {
            const parentRequest: any = await this.commonService.insertItem('people/parentByEmail', {email});
            if (parents.findIndex(parent => parent.email === parentRequest.object.email) === -1) {
                parents.push(parentRequest.object);
            }
            tempParents.push(parentRequest.object);
        }

        for (const parent of parents) {
            const multipleEmails = tempParents.filter(p => p.email === parent.email);
            const model = {
                label: parent.parentFirstName,
                displayName: multipleEmails.length > 1 ? `${parent.firstName} ${parent.lastName} (x ${multipleEmails.length})` : `${parent.firstName} ${parent.lastName}`,
                email: parent.email,
                phone: parent.telephone
            };
            this.emails.push(model);
        }

        this.isLoading = false;
    }

    initializeUser() {
        this.emails = [];
        const userEmail = this.incomingUserInfo[0];
        this.http.post('people/userByEmail', {param: userEmail}).subscribe(response => {
            const parent: any = response[0];
            this.parent = response[0];
            console.log(this.parent);
            const model = {
                label: parent.parentFirstName,
                displayName: `${parent.firstName} ${parent.lastName}`,
                email: userEmail,
                phone: parent.telephone
            };
            this.emails.push(model);
        });
    }

    async ngOnInit() {
        // this.dialogRef.updateSize('100%', '100%');
        this.emailsCtrl.valueChanges
            .pipe(
                debounceTime(500),
                tap(() => {
                    this.errorMsg = '';
                    this.filteredUsers = [];
                    this.isLoading = true;
                }),
                switchMap(value => this.http.post('people/userByEmail', {param: value})
                    .pipe(
                        finalize(() => {
                            this.isLoading = false;
                        }),
                    )
                )
            )
            .subscribe(data => {
                if (data) {
                    this.filteredUsers = data;
                }
            });
    }

    async initDepartmentEmails() {
        try {
            const result = await this.commonService.getList(`college/emails`);
            this.departmentEmails = result.object;

        } catch (e) {
            this.toastMessagesService.toastErrorMessage(e.message);
        }
    }

    displayFn(user: any): string {
        return user && user.first_name ? user.first_name : '';
    }


    selected(event: MatAutocompleteSelectedEvent): void {
        console.log(event.option);
        const model = {
            label: event.option.viewValue,
            displayName: `${event.option.value.firstName} ${event.option.value.lastName}`,
            email: event.option.value.email[0],
            phone: event.option.value.telephone
        };
        // this.emails.push(event.option.viewValue);
        this.emails.push(model);
        this.emailInput.nativeElement.value = '';
        this.emailsCtrl.setValue(null);
    }

    removeEmail(email: any) {
        const index = this.emails.indexOf(email);

        if (index >= 0) {
            this.emails.splice(index, 1);
        }
    }

    addEmail($event: any) {
        // @ts-ignore
        const input = event.input;
        // @ts-ignore
        const value = event.value;

        // Add email
        if ((value || '').trim()) {
            this.emails.push(value.trim());
        }

        // Reset the input value
        if (input) {
            input.value = '';
        }

        this.emailsCtrl.setValue(null);
    }

    filter(name: string) {
        try {
            if (name) {
                return this.departmentEmails.filter(email =>
                    email.email.toLowerCase().indexOf(name.toLowerCase()) === 0);
            }
        } catch (e) {

        }
    }


    close() {
        this.dialogRef.close();
    }

    async groupChange() {
        try {
            this.isLoading = true;
            if (this.mode === 0 || this.mode === 1) {
                switch (this.selectedRecipientGroup.id) {
                    case 1:
                        this.emails = [];
                        for (const parent of this.incomingUserInfo.accepted) {
                            if (parent.fatherInfo.id) {
                                const fatherModel = {
                                    label: parent.fatherInfo.firstName,
                                    displayName: `${parent.fatherInfo.firstName} ${parent.fatherInfo.lastName}`,
                                    email: parent.fatherInfo.email,
                                    phone: parent.fatherInfo.telephone
                                };
                                const index = this.emails.findIndex(email  => email.email === fatherModel.email);
                                if (index === -1) {
                                    this.emails.push(fatherModel);
                                }
                            }

                            if (parent.motherInfo.id) {
                                const motherModel = {
                                    label: parent.motherInfo.firstName,
                                    displayName: `${parent.motherInfo.firstName} ${parent.motherInfo.lastName}`,
                                    email: parent.motherInfo.email,
                                    phone: parent.motherInfo.telephone
                                };
                                const index = this.emails.findIndex(email  => email.email === motherModel.email);
                                if (index === -1) {
                                    this.emails.push(motherModel);
                                }
                            }
                        }
                        break;
                    case 2:
                        this.emails = [];
                        for (const parent of this.incomingUserInfo.denied) {
                            if (parent.fatherInfo.id) {
                                const fatherModel = {
                                    label: parent.fatherInfo.firstName,
                                    displayName: `${parent.fatherInfo.firstName} ${parent.fatherInfo.lastName}`,
                                    email: parent.fatherInfo.email,
                                    phone: parent.fatherInfo.telephone
                                };
                                const index = this.emails.findIndex(email  => email.email === fatherModel.email);
                                if (index === -1) {
                                    this.emails.push(fatherModel);
                                }
                            }

                            if (parent.motherInfo.id) {
                                const motherModel = {
                                    label: parent.motherInfo.firstName,
                                    displayName: `${parent.motherInfo.firstName} ${parent.motherInfo.lastName}`,
                                    email: parent.motherInfo.email,
                                    phone: parent.motherInfo.telephone
                                };
                                const index = this.emails.findIndex(email  => email.email === motherModel.email);
                                if (index === -1) {
                                    this.emails.push(motherModel);
                                }
                            }
                        }
                        // const tempDeniedEmails = this.incomingUserInfo.denied.map((parent) => {
                        //     return parent.parentEmail;
                        // });
                        // const deniedUsers: any = [...new Set(tempDeniedEmails)];
                        // for (const tempUser of deniedUsers) {
                        //     const multipleEmails = this.incomingUserInfo.denied.filter(p => p.parentEmail === tempUser);
                        //     const parent = this.incomingUserInfo.denied.find(u => tempUser === u.parentEmail);
                        //
                        //     const model = {
                        //         label: parent.parentFirstName,
                        //         displayName: multipleEmails.length > 1 ? `${parent.parentFirstName} ${parent.parentLastName} (x ${multipleEmails.length})` : `${parent.parentFirstName} ${parent.parentLastName}`,
                        //         email: parent.parentEmail,
                        //         phone: parent.parentTelephone
                        //     };
                        //     this.emails.push(model);
                        // }
                        break;
                    case 3:
                        this.emails = [];
                        for (const parent of this.incomingUserInfo.pending) {
                            if (parent.fatherInfo.id) {
                                const fatherModel = {
                                    label: parent.fatherInfo.firstName,
                                    displayName: `${parent.fatherInfo.firstName} ${parent.fatherInfo.lastName}`,
                                    email: parent.fatherInfo.email,
                                    phone: parent.fatherInfo.telephone
                                };
                                const index = this.emails.findIndex(email  => email.email === fatherModel.email);
                                if (index === -1) {
                                    this.emails.push(fatherModel);
                                }
                            }

                            if (parent.motherInfo.id) {
                                const motherModel = {
                                    label: parent.motherInfo.firstName,
                                    displayName: `${parent.motherInfo.firstName} ${parent.motherInfo.lastName}`,
                                    email: parent.motherInfo.email,
                                    phone: parent.motherInfo.telephone
                                };
                                const index = this.emails.findIndex(email  => email.email === motherModel.email);
                                if (index === -1) {
                                    this.emails.push(motherModel);
                                }
                            }
                        }
                        // const tempEmails = this.incomingUserInfo.pending.map((parent) => {
                        //     return parent.parentEmail;
                        // });
                        // const pendingUsers: any = [...new Set(tempEmails)];
                        // console.log(pendingUsers);
                        // for (const tempUser of pendingUsers) {
                        //     const multipleEmails = this.incomingUserInfo.pending.filter(p => p.parentEmail === tempUser);
                        //     const parent = this.incomingUserInfo.pending.find(u => tempUser === u.parentEmail);
                        //
                        //     const model = {
                        //         label: parent.parentFirstName,
                        //         displayName: multipleEmails.length > 1 ? `${parent.parentFirstName} ${parent.parentLastName} (x ${multipleEmails.length})` : `${parent.parentFirstName} ${parent.parentLastName}`,
                        //         email: parent.parentEmail,
                        //         phone: parent.parentTelephone
                        //     };
                        //     this.emails.push(model);
                        // }
                        break;
                }
            } else {
                await this.initializeUsers(this.selectedRecipientGroup.id);
            }
        } catch (e) {
            console.log(e);
        } finally {
            this.isLoading = false;
        }
    }

    async sendDirectMessage() {
        const model = {
            parentId: this.parent.userId,
            categoryId: 1,
            message: this.htmlContent,
            subject: this.subject
        };

        try {
            this.isLoading = true;
            this.loading = true;
            await this.messageService.sendParentMessage(model);
            this.toastMessagesService.toastMessages('Το μήνυμα στάλθηκε με επιτυχία');
            setTimeout(() => {
                this.dialogRef.close();
            }, 1000);
        } catch (e) {
            this.toastMessagesService.toastErrorMessage(e.message);
        } finally {
            this.isLoading = false;
            this.loading = false;
        }
    }

    async sendMessage() {
        const emails = [];
        const telephones = [];
        const users = [];
        for (const userInfo of this.emails) {
            users.push({email: userInfo.email, telephone: userInfo.phone});
            emails.push(userInfo.email);
            telephones.push(userInfo.phone);
        }
        const model = {
            emails,
            users,
            telephones,
            provider: this.notificationMode,
            subject: this.subject,
            message: this.htmlContent,
            text: this.transform(this.htmlContent)
        };

        try {
            this.isLoading = true;
            this.loading = true;
            await this.messageService.sendMessage(model);
            this.toastMessagesService.toastMessages('Η αποστολή ενημέρωσης ολοκληρώθηκε');
            this.dialogRef.close();
        } catch (e) {
            this.toastMessagesService.toastErrorMessage(e.message);
        } finally {
            this.isLoading = false;
            this.loading = false;
        }
    }
}
